import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Log } from "@/types/log.types";

interface LogState {
  logs: Log[];
  loading: boolean;
  error: string | null;
}

const initialState: LogState = {
  logs: [],
  loading: false,
  error: null,
};

const logSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    addLog: (state, action: PayloadAction<Log>) => {
      state.logs.unshift(action.payload);
    },
    clearLogs: (state) => {
      state.logs = [];
    },
  },
});

export const { addLog, clearLogs } = logSlice.actions;
export default logSlice.reducer;
